import { ValidationMessage } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { LinkCodesActionType } from './constants';

export interface CodeField {
  id: number;
  label: string;
  searchRequired: boolean;
}

export interface CodetableMetadata {
  hierarchy: boolean;
  category: CodeField;
  type: CodeField;
}

export interface ListBranchModel {
  codetable: number;
  category: number;
  includeInactiveCodes: boolean;
  activeType: ActionPayloadType;
}

export interface ListBranchItem {
  id: number;
  description: string;
  icon: string;
  colour: number;
  disabled: Date;
  childrenCount: number;
  node: ComplexValue<number>;
  userGroup: ComplexValue<number>[];
  caseType: ComplexValue<number>[];
  type: ComplexValue<number>[];
}

export interface ListBranch {
  id: number;
  items: ListBranchItem[];
  numberOfResults: number;
}

export interface ListBranchState {
  id: number;
  fetching: boolean;
  open: boolean;
}

export interface ListAction {
  path: number[];
  propagate: boolean;
  type: LinkCodesActionType;
  category?: number;
}

export enum ActionPayloadType {
  userGroup = 'subset',
  type = 'class',
  caseType = 'application'
}

export enum Visibility {
  all = 'all',
  selected = 'selected',
  unselected = 'unselected'
}

export interface LinkCodesState {
  fetchingBreadcrumbs: boolean;
  breadcrumbsOptions: ComplexValue<number>[];
  nodeCodetable: number;

  fetchingMetadata: boolean;
  codetableMetadata: CodetableMetadata;

  fetchingCodetableAccess: number;
  codetableAccess: AccessCodetables;

  requestedModel: ListBranchModel;
  listBranch: ListBranch[];
  listBranchState: ListBranchState[];

  listActions: ListAction[];
  updating: boolean;
  actionErrors: ValidationMessage[];
  activeValueError: ValidationMessage;

  codetable: ComplexValue<number>;
  category: ComplexValue<number>;
  includeInactive: boolean;
  activeValue: ComplexValue<number>;
  activeType: ActionPayloadType;

  visiblity: Visibility;
  lastSelectedRow: number;
  selectedRows: number[][];
}

export type CodetablesAccessWire = AccessCodetables[];

export interface AccessCodetables {
  id: number;
  create: boolean;
  administrationCentral: boolean;
}
